// extracted by mini-css-extract-plugin
export default {"pageWrapper":"_1rMHu","centeredLogo":"NQd5p","loginWrapper":"x6f7m","pageTitle":"_2Ruld","centered":"_2BKHn","centeredOptions":"_2XJ-S","link":"rAdp5","logo":"_3EhDV"};